<template>
  <div id="shopping-model">
    <div
      class="shopping-dialogs"
      v-if="modelInfo.modelType == 'confirmAfterSaleCanel' || modelInfo.modelType == 'confirmCanel' || modelInfo.modelType == 'confirmGetGoods' || modelInfo.modelType == 'confirmAfterSale'"
    >
      <el-dialog
        title="消息提示"
        :visible.sync="modelInfo.modelType == 'confirmAfterSaleCanel' || modelInfo.modelType == 'confirmCanel' || modelInfo.modelType == 'confirmGetGoods' || modelInfo.modelType == 'confirmAfterSale'"
        @close="operaCanel"
      >
        <div
          class="shopping-dialog-message"
          v-if="modelInfo.modelType == 'confirmCanel'"
        >请问您是否确定要取消该订单？</div>
        <div
          class="shopping-dialog-message"
          v-if="modelInfo.modelType == 'confirmGetGoods'"
        >请问您是否已经收到该订单货物？</div>
        <div
          class="shopping-dialog-message"
          v-if="modelInfo.modelType == 'confirmAfterSale'"
        >请问您是否要申请售后？</div>
        <div
          class="shopping-dialog-message"
          v-if="modelInfo.modelType == 'confirmAfterSaleCanel'"
        >请问您是否要取消售后？</div>

        <div class="shopping-dialog-address-footer">
          <el-button
            plain
            class="shoppingbtn-plan shopp-btn-danger"
            @click="operaConfirm"
            :loading="sureBtn"
          >确认</el-button>
          <el-button plain class="shoppingbtn-plan shopp-btn-default" @click="operaCanel">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="shopping-dialog" v-if="modelInfo.modelType == 'confirmReturnAddress'">
      <el-dialog
        title="退货地址"
        :visible.sync="modelInfo.modelType == 'confirmReturnAddress'"
        @close="operaCanel"
        center
      >
        <div class="shopping-dialog-address-sure">
          <ul>
            <li>
              <label>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</label>
              <font>{{returnAddress.address}}</font>
            </li>
            <li>
              <label>收&nbsp;&nbsp;货&nbsp;&nbsp;人:</label>
              <font>{{returnAddress.name}}</font>
            </li>
            <li>
              <label>联系方式：</label>
              <font>{{returnAddress.phone}}</font>
            </li>
          </ul>
          <div class="shopping-dialog-address-tips fl">
            <label>温馨提示：</label>
            <p>请按照以上地址及联系方式寄送，否则无法正常完成退货流程，以免给大家带来不便，谢谢配合！</p>
          </div>
        </div>

        <div class="shopping-dialog-address-footer">
          <el-button plain class="shoppingbtn-plan shopp-btn-danger" @click="operaCanel">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <div
      class="shopping-dialog shopping-dialog_logistics"
      v-if="modelInfo.modelType == 'confirmlogistics'"
    >
      <el-dialog
        title="查看物流"
        :visible.sync="modelInfo.modelType == 'confirmlogistics'"
        @close="operaCanel"
        center
      >
        <div class="shopping-dialog-logistics">
          <div class="shopping-dialog-logistics_info fl">
            <div class="shopping-dialog-logistics_info-img fl">
              <img :src="modelInfo.imgUrl" class="fl">
              <span>{{modelInfo.imageSize}}件商品</span>
            </div>
            <div class="shopping-dialog-logistics_ul fl">
              <ul>
                <li>
                  <label>配送企业：</label>
                  <font>{{logisticsInfo.logisticsCompanyName}}</font>
                </li>
                <li>
                  <label>快递单号：</label>
                  <font>{{logisticsInfo.logisticsNo}}</font>
                </li>
              </ul>
            </div>
          </div>
          <div class="shopping-dialog-logistics_line fl">
            <el-scrollbar style="height: 100%">
              <div
                class="shopping-dialog-line-step fl"
                :class="index == 0 && 'on'"
                v-for="(item,index) in logisticsList"
                :key="index"
              >
                <div class="shopping-dialog-line-step_move">
                  <div class="shopping-step_move-height fl"></div>
                  <div class="shopping-step_move-raduis fl"></div>
                </div>
                <div class="shopping-step_detail">
                  <dl>
                    <dt>{{item.content}}</dt>
                    <dd>{{item.time}}</dd>
                  </dl>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>

        <div class="shopping-dialog-address-footer">
          <el-button plain class="shoppingbtn-plan shopp-btn-danger" @click="operaCanel">确定</el-button>
        </div>
      </el-dialog>
    </div>

    <div
      class="shopping-dialog shopping-dialog_delivergoods"
      v-if="modelInfo.modelType == 'confirmDeliverGoods'"
    >
      <el-dialog
        title="发货信息"
        :visible.sync="modelInfo.modelType == 'confirmDeliverGoods'"
        @close="operaCanel"
        center
      >
        <div class="shopping-dialog-delivergoods">
          <el-form label-width="80px" :model="deliverForm" :rules="deliverRules" ref="deliverForm">
            <el-form-item label="物流公司：" prop="logisticsCompany">
              <el-select filterable placeholder="请选择物流公司" v-model="deliverForm.logisticsCompany">
                <el-option
                  v-for="(item,index) in allLogistics"
                  :key="index"
                  :label="item.companyName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流单号：" prop="logisticsNo">
              <el-input v-model="deliverForm.logisticsNo"></el-input>
            </el-form-item>
            <el-form-item label="发货备注：" prop="logisticsRemark">
              <el-input type="textarea" v-model="deliverForm.logisticsRemark"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="shopping-dialog-address-footer shopping-dialog-delivergoods_footers">
          <el-button
            plain
            class="shoppingbtn-plan shopp-btn-danger"
            @click="operaSureLog('deliverForm')"
            :loading="sureBtn"
          >确定</el-button>
          <el-button plain class="shoppingbtn-plan shopp-btn-default" @click="operaCanel">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  viewOrderDetails,
  cancelOrder,
  confirmReceipt,
  viewLogistics,
  applyForAfterSale,
  viewReturnProductAddress,
  selectAllLogisticsCompany,
  confirmShipment
} from "@/api";
export default {
  name: "shopping-model",
  props: ["visibleModel"],
  watch: {
    visibleModel() {
      if (this.visibleModel == "") {
        this.modelInfo.modelType = "";
      } else {
        this.modelInfo = JSON.parse(this.visibleModel);
      }
      this.operaInit();
    }
  },
  data() {
    return {
      sureBtn: false,
      modelInfo: {
        modelType: "" //confirmCanel:取消订单，confirmGetGoods：收货，confirmlogistics:订单物流
      },
      logisticsList: [],
      logisticsInfo: {
        logisticsCompanyName: "",
        logisticsNo: ""
      },
      returnAddress: {},
      deliverForm: {
        shipmentUser: 1,
        orderType: 2,
        logisticsCompany: "",
        logisticsNo: "",
        logisticsRemark: ""
      },
      deliverRules: {
        logisticsCompany: [
          { required: true, message: "请选择物流公司", trigger: "blur" }
        ],
        logisticsNo: [
          { required: true, message: "请填写物流单号", trigger: "blur" }
        ],
        logisticsRemark: [
          { required: true, message: "请填写发货备注", trigger: "blur" }
        ]
      },
      allLogistics: []
    };
  },
  created() {},
  methods: {
    operaInit() {
      if (this.modelInfo.modelType == "confirmlogistics") {
        this.operaLogistics();
      } else if (this.modelInfo.modelType == "confirmReturnAddress") {
        this.operaReturnAddress();
      } else if (this.modelInfo.modelType == "confirmDeliverGoods") {
        this.operaGetAllLogistics();
      }
    },
    //查看物流
    operaLogistics() {
      let prams = {};
      prams.orderType = 1;
      prams.id = this.modelInfo.id;
      if (this.$route.params.id) {
        prams.id = this.$route.params.id;
      }
      if (this.modelInfo.orderType) {
        prams.orderType = this.modelInfo.orderType;
      }
      viewLogistics(prams).then(res => {
        this.logisticsList = res.obj[0].messageDTOList;
        this.logisticsInfo.logisticsCompanyName =
          res.obj[0].logisticsCompanyName;
        this.logisticsInfo.logisticsNo = res.obj[0].logisticsNo;
      });
    },
    operaConfirm() {
      this.sureBtn = true;
      if (this.modelInfo.modelType == "confirmCanel") {
        this.operaCanelOrder();
      } else if (this.modelInfo.modelType == "confirmGetGoods") {
        this.operaSureOrder();
      } else if (this.modelInfo.modelType == "confirmAfterSale") {
        this.operaAfterSale();
      } else if (this.modelInfo.modelType == "confirmAfterSaleCanel") {
        this.operaAfterSale();
      }
    },
    //申请售后
    operaAfterSale() {
      let prams = {};
      if (this.$route.params.id) {
        prams.id = this.$route.params.id;
      } else {
        prams.id = this.modelInfo.id;
      }
      applyForAfterSale(prams).then(res => {
        if (res.code == 20001) {
          this.operaSure();
          this.sureBtn = false;
        } else {
          this.sureBtn = false;
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },
    //取消订单
    operaCanelOrder() {
      let prams = {};
      prams.orderType = 1;
      if (this.$route.params.id) {
        prams.id = this.$route.params.id;
      } else {
        prams.id = this.modelInfo.id;
      }
      cancelOrder(prams).then(res => {
        if (res.code == 20001) {
          this.operaSure();
          this.sureBtn = false;
        } else {
          this.sureBtn = false;
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },
    //确认收货
    operaSureOrder() {
      let prams = {};
      prams.orderType = this.modelInfo.orderType;
      if (this.$route.params.id) {
        prams.id = this.$route.params.id;
      } else {
        prams.id = this.modelInfo.id;
      }
      confirmReceipt(prams).then(res => {
        if (res.code == 20001) {
          this.operaSure();
          this.sureBtn = false;
        } else {
          this.sureBtn = false;
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },

    //確認發貨
    operaSureLog(formName) {
      if (this.$route.params.id) {
        this.deliverForm.id = this.$route.params.id;
      } else {
        this.deliverForm.id = this.modelInfo.id;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          confirmShipment(this.deliverForm).then(res => {
            if (res.code == 20001) {
              this.operaSure();
            }
            this.sureBtn = false;
            this.$message({
              type: res.code == 20001 ? "success" : "error",
              message: res.msg
            });
          });
        } else {
          this.sureBtn = false;
        }
      });
    },
    //获取所有物流信息
    operaGetAllLogistics() {
      selectAllLogisticsCompany({}).then(res => {
        this.allLogistics = res.obj;
      });
    },
    //查看收货地址
    operaReturnAddress() {
      viewReturnProductAddress({ id: this.$route.params.id }).then(res => {
        this.returnAddress = res.obj;
      });
    },
    operaCanel() {
      this.$emit("operaCanel", this.modelInfo.modelType);
    },

    operaSure() {
      this.$emit("operaSure", this.modelInfo.modelType);
    }
  }
};
</script>
<style type="text/css">
/*dialog公共样式*/
.shopp-btn-default.el-button:hover,
.shopp-btn-default.el-button:focus {
  color: #f83c57;
  background: #fff0f2;
  border: 1px solid #f83c57;
}
.shopp-btn-danger.el-button:hover,
.shopp-btn-danger.el-button:focus {
  color: #ffffff;
  background: #df364e;
  border: 1px solid #f83c57;
}
.shopp-btn-default {
  width: 100px;
  height: 32px;
  color: #f83c57;
  border: 1px solid #f83c57;
}
.shopp-btn-danger {
  width: 100px;
  height: 32px;
  color: #ffffff;
  background: #f83c57;
  border: none;
}
.shopping-dialogs .el-dialog {
  width: 500px;
  border-radius: 10px;
}
.shopping-dialogs .el-dialog__title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.shopping-dialog-message {
  width: 100%;
  text-align: center;
  font-size: 16px;
}

.shopping-dialog .el-dialog {
  width: 600px;
  height: 500px;
  border-radius: 20px;
}
.shopping-dialog .el-dialog__title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}
.shopping-dialog .el-dialog__header {
  padding: 0;
  padding-top: 64px;
}
.shopping-dialog .el-dialog__body {
  padding: 0;
}
.shopping-dialog-address-list {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 30px;
  width: 100%;
}
.shopping-dialog-address-list_l {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  width: 100%;
  height: 90px;
  background: #f6f7f9;
}
.shopping-dialog-address-list_l-radio {
  margin-left: 45px;
  width: 18px;
}
.shopping-dialog-address-list_l-radio span {
  float: left;
  width: 18px;
  height: 18px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  border: 1px solid #c0c5cf;
  border-radius: 50%;
  cursor: pointer;
}
.shopping-dialog-address-list_l-radio.on span {
  border: none;
  background: #f83c57;
}
.shopping-dialog-address-list_l-info {
  flex: 1;
}
.shopping-dialog-address_info {
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 14px;
  color: #666666;
}
.shopping-dialog-address_info span {
  margin-left: 25px;
  margin-right: 20px;
}
.shopping-dialog-address_info font {
  color: #222222;
}
.shopping-dialog-address-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 60px;
  width: 100%;
}
.shopping-dialog-address-footer .shopp-btn-danger,
.shopping-dialog-address-footer .shopp-btn-default {
  margin-left: 10px;
  margin-right: 10px;
  width: 120px;
  height: 42px;
}

/*退货*/
.shopping-dialog-address-sure {
  padding-left: 110px;
  padding-right: 90px;
  width: 100%;
}
.shopping-dialog-address-tips {
  font-size: 12px;
  color: #f83c57;
}

.shopping-dialog-address-sure ul {
  float: left;
  margin-top: 40px;
  width: 100%;
}
.shopping-dialog-address-sure ul li {
  float: left;
  margin-top: 20px;
  width: 100%;
  font-size: 14px;
}
.shopping-dialog-address-sure ul li label {
  float: left;
  width: 70px;
  color: #666666;
}
.shopping-dialog-address-sure ul li font {
  color: #222222;
}
.shopping-dialog-address-tips {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
}
.shopping-dialog-address-tips label {
  float: left;
  width: 70px;
  line-height: 24px;
}
.shopping-dialog-address-tips p {
  float: left;
  flex: 1;
  line-height: 24px;
}
/*物流*/
.shopping-dialog_logistics .el-dialog {
  width: 600px;
  height: 700px;
  border-radius: 20px;
}
.shopping-dialog-logistics {
  padding-left: 50px;
  padding-right: 50px;
  width: 100%;
}
.shopping-dialog-logistics_info {
  display: flex;
  align-items: center;
  margin-top: 36px;
  width: 100%;
  height: 120px;
  background: #f6f7f9;
}
.shopping-dialog-logistics_info-img {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 50px;
  margin-right: 48px;
  width: 80px;
  height: 80px;
  background: #ffffff;
}
.shopping-dialog-logistics_info-img img {
  max-width: 80px;
  max-height: 80px;
}
.shopping-dialog-logistics_info-img span {
  position: absolute;
  bottom: 0px;
  left: 0;
  float: left;
  width: 80px;
  height: 20px;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 20px;
  background: #333333;
  opacity: 0.5;
}
.shopping-dialog-logistics_ul {
  flex: 1;
}

.shopping-dialog-logistics_ul ul {
  float: left;
  width: 100%;
}

.shopping-dialog-logistics_ul li {
  float: left;
  margin-top: 5px;
  width: 100%;
}

.shopping-dialog-logistics_ul li label {
  float: left;
  width: 70px;
  color: #999999;
}
.shopping-dialog-logistics_ul li font {
  color: #444444;
}
.shopping-dialog-logistics_line {
  margin-top: 40px;
  padding-left: 64px;
  width: 100%;
  height: 260px;
  overflow: hidden;
}
.shopping-dialog-line-step {
  width: 100%;
  display: flex;
}
.shopping-dialog-line-step_move {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 15px;
}
.shopping-step_move-height {
  width: 3px;
  min-height: 65px;
  height: 100%;
  background: #d5d9e3;
}
.shopping-step_move-raduis {
  position: absolute;
  top: 0px;
  left: 2.4px;
  width: 10px;
  height: 10px;
  background: #d5d9e3;
  border-radius: 50%;
}
.shopping-step_detail {
  display: table-cell;
  padding-left: 15px;
  flex: 1;
  padding-bottom: 15px;
}
.shopping-step_detail dl,
.shopping-step_detail dl dt,
.shopping-step_detail dl dd {
  float: left;
  width: 100%;
}
.shopping-step_detail dl {
  font-size: 12px;
  color: #999999;
}

.shopping-step_detail dl dd {
  padding-top: 5px;
}
.shopping-dialog-line-step.on .shopping-step_move-raduis {
  top: 0px;
  left: 0px;
  width: 14px;
  height: 14px;
  background: #2ecfa7;
}
.shopping-dialog-line-step.on .shopping-step_detail dl {
  color: #2ecfa7;
}
.shopping-dialog-line-step.on .shopping-step_detail dl dt {
  font-weight: bold;
}
.shopping-dialog-logistics_line .el-scrollbar__wrap {
  overflow-x: hidden;
}
/*发货物流填写*/
.shopping-dialog_delivergoods {
  width: 600px;
  height: 500px;
  border-radius: 20px;
}
.shopping-dialog-delivergoods {
  padding-top: 48px;
  margin-left: 138px;
  width: 310px;
}
.shopping-dialog-delivergoods .el-form-item__label {
  font-size: 14px;
  color: #666666;
  padding: 0;
}
.shopping-dialog-delivergoods .el-select {
  width: 100%;
}
.shopping-dialog-delivergoods .el-textarea__inner {
  height: 102px;
}
.shopping-dialog-delivergoods_footers {
  padding-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingModel.vue